module.exports = __webpack_public_path__ + "static/media/file_type_dwg.a6f8f091.svg";